import type { OutboxPort } from '@Domain/Ports/Outbox/OutboxPort';
import PortsContext from '@UI/Providers/PortsProvider/PortsContext';
import * as React from 'react';

function useOutboxPort(): OutboxPort {
	const context = React.useContext(PortsContext);

	if (context === null) {
		throw new Error('useOutboxPort doit être utilisé à l’intérieur d’un PortsProvider.');
	}

	return context.outbox;
}

export default useOutboxPort;
